import React from 'react'
import CatholicHouseholdMemberQuery from "./CatholicHouseholdMemberQuery";


export const CatholicHouseholdMemberQueryConfirmation = ({
                                                             ...props
                                                         }) => <CatholicHouseholdMemberQuery
    sacrament_type={"confirmation"} {...props} />


